import { render } from "./App.vue?vue&type=template&id=9a15f3f8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=9a15f3f8&lang=css"

import exportComponent from "/builds/unifybusiness/pics/games/arcade-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__